export default __webpack_public_path__ + "static/media/self-picture.251c1ea5.jpg";